<template>
    <div class="d-flex flex-1 h-100 overflow-hidden">
        <v-card class="report-container w-100 p-0" style="border-radius: 12px; margin-bottom: 24px"">
            <v-toolbar class="shadow-none" style="flex: unset; " content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_MoveUser") }}</v-toolbar-title>
            </v-toolbar>


            <div class="border-top p-4 flex-1 overflow-auto">
                    <div class="p-0 d-flex gap-2 align-center">
                        <v-label class="label_required mr-4">{{ $t("res_Label_SelectUser") }}<span> *</span></v-label>
                        <StructureUserSelector style="width: 40%;" :showInternalUsers="true" :showInternalStructures="false"
                            :showExternalStructures="false" :excludeSelf="false" :isMultiple="false" :addressBook_header="$t('res_Label_SelectUser')"
                            :selectedStructureUser="fromUserQuery" @structureUserSelectChanged="selectFromUserQuery">
                        </StructureUserSelector>
                        <v-btn @click="getAllOpenedTransferForUser" class="ml-2" color="primary">{{ $t("res_ButtonText_Search") }}</v-btn>
                    </div>
                    <hr>
                    <div class="d-flex gap-2 my-4">
                        <v-btn :disabled="selectedTransfers.length == 0" @click="setUpReleaseTransfersDialog" class="primary d-flex align-center">
                            {{ $t("res_ButtonText_Release") }}
                            <v-icon right>mdi-check</v-icon>
                        </v-btn>
                        <v-btn :disabled="selectedTransfers.length == 0" @click="setUpCloseTransfersDialog" class="primary d-flex align-center">
                            {{ $t("res_ButtonText_Close") }}
                            <v-icon right>mdi-close-box</v-icon>
                        </v-btn>
                        <v-btn :disabled="selectedTransfers.length == 0" @click="openAddToUserDialog" class="primary d-flex align-center">
                            {{ $t("res_ButtonText_Transfer") }}
                            <v-icon right>mdi-send</v-icon>
                        </v-btn>
                        <v-btn :disabled="isMoveBtnDisabled" @click="openMoveToStructureDialog(1)" class="primary d-flex align-center">
                            {{ $t("res_ButtonText_Move") }}
                            <v-icon right>mdi-transfer-right</v-icon>
                        </v-btn>
                        <v-btn :disabled="isMoveWithLettersBtnDisabled" @click="openMoveToStructureDialog(2)" class="primary d-flex align-center">
                            {{ $t("res_ButtonText_MoveWithLetters") }}
                            <v-icon right>mdi-transfer-right</v-icon>
                        </v-btn>
                    </div>       

                    <Pagination class="mb-2" :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize"
                    :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged"
                    :showPageSize="true" :showMargin="false"></Pagination>

                    <v-data-table id="ListCorrespondancesTable" class="elevation-1" :mobile-breakpoint="0" :headers="headers" 
                    :items="all_transfers" disable-sort hide-default-footer show-select @input="itemSelected" :items-per-page="pagingData.pageSize">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>
                                        <v-checkbox v-model="selectedTransfers" :value="item"></v-checkbox>
                                    </td>
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.subject }}</td>
                                    <td>{{ item.fromStructure }}</td>
                                    <td>{{ item.fromUser }}</td>
                                    <td>{{ item.status }}</td>
                                    <td>{{ item.transferPurpose }}</td>
                                    <td>{{ utils.formatDateTimeWithTime(item.transferDate) }}</td>
                                </tr>
                            </template>

                            <template v-slot:no-data>
                                <v-row class="p-5">
                                    <img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
                                    <p class="m-0">{{ $t("res_Msgs_AlertNoItemsHere") }}</p>
                                </v-row>
                            </template>
                    </v-data-table>      
            </div>

        </v-card>

        

        <v-dialog v-model="addToUserDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_DialogTitle_Transfer") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="addToUserDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column flex-1">
                    <div class="p-4 flex-1 overflow-auto">
                        <div class="mb-3-rem">
                            <v-label class="label_required mb-2">{{ $t("res_Label_SelectUser") }}<span> *</span></v-label>
                            <StructureUserSelector :showInternalUsers="true" :showInternalStructures="false"
                                :showExternalStructures="false" :excludeSelf="false" :isMultiple="false"
                                :selectedStructureUser="toUserQuery" @structureUserSelectChanged="selectToUserQuery">
                            </StructureUserSelector>
                        </div>
                    </div>
                    <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1"  @click="addToUserDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn class="primary flex-1"  @click="setUpTransferTransfersDialog">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="moveToStructureDialog" content-class="dialog with-fixed-actions bg-white w-40 right" fullscreen width="70%" scrollable>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t("res_DialogTitle_MoveToStructure") }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="moveToStructureDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column flex-1">
                    <div class="p-4 flex-1 overflow-auto">
                        <div class="mb-3-rem">
                            <v-label class="label_required mb-2">{{ $t("res_Label_SelectStrucutre") }}<span> *</span></v-label>
                            <StructureUserSelector :showInternalUsers="false" :showInternalStructures="true"
                                :showExternalStructures="false" :excludeSelf="false" :isMultiple="false"
                                :selectedStructureUser="toStructureQuery" @structureUserSelectChanged="selectToStructureQuery">
                            </StructureUserSelector>
                        </div>
                    </div>
                    <v-card-actions class="top-shadow gap-3">
                        <v-btn class="light-blue flex-1"  @click="moveToStructureDialog = false">{{$t("res_ButtonText_Cancel")}}</v-btn>
                        <v-btn class="primary flex-1"  @click="setUpMoveUserToStructureDialog">{{$t("res_ButtonText_Save")}}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="informationDialogOptions.visible" content-class="small-dialog" width="20%">
            <v-card>
                <v-card-title>{{ informationDialogOptions.title }}</v-card-title>
                <div class="bg-white">
                    <div class="card-body">
                        <p class="mb-0">{{ informationDialogOptions.text }}</p>
                    </div>
                    <v-card-actions class="gap-2 sticky-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="light-blue" @click="informationDialogOptions.visible = false">{{ $t('Cancel')}}</v-btn>
                        <v-btn 
                        @click="informationDialogOptions.confirmFunction(); informationDialogOptions.visible = false;"
                        color="primary">{{ $t('Confirm')}}</v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

    </div>

    
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants';
import * as utils from '@/assets/js/common.js';
import StructureUserSelector from '@/components/StructureUserSelector.vue';
import Pagination from '@/components/Pagination.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue'


export default {
    name: 'ManageMoveUser',
    components: {
        StructureUserSelector,
        Pagination,
        ConfirmDialog
    },
    data() {
        return {
            informationDialogOptions: {
                title: '',
                text: '',
                confirmFunction: null,
                cancelFunction: null,
                visible: false
            },
            utils: utils,
            addToUserDialog: false,
            moveToStructureDialog: false,
            isMoveBtnDisabled: true,
            isMoveWithLettersBtnDisabled: true,
            fromUserQuery: { id: 0, name: '' },
            toUserQuery: { id: 0, name: '' },
            toStructureQuery: { id: 0, name: '' },
            fromUserId: 0,
            fromStructureId: 0,
            toUserId: 0,
            toStructureId: 0,
            all_transfers: [],
            headers: [
                { text: '', value: 'data-table-select' },
                { text: this.$t("res_GridHeaders_Id"), value: 'id' },
                { text: this.$t("res_Label_Subject"), value: 'subject'},
                { text: this.$t("res_GridHeaders_FromStructure"), value: 'fromStructure' },
                { text: this.$t("res_GridHeaders_FromUser"), value: 'fromUser' },
                { text: this.$t("res_Label_Status"), value: 'statusId' },
                { text: this.$t("res_Label_Purpose"), value: 'transferPurpose' },
                { text: this.$t("res_Label_TransferDate"), value: 'transferDate' },
            ],
            pagingData: {
                pageSize: 10,
                pageIndex: 0,
                totalCount: 0
            },
            selectedTransfers: [],
            moveActionType: 0
        }
    },
    methods: {
        backToAdminPage() {
            this.$router.push('/admin');
        },
        openMoveToStructureDialog(type) {
            this.moveToStructureDialog = true;
            this.moveActionType = type;
        },
        selectFromUserQuery(item) {
            this.fromUserQuery = item;
            var stringId = item.id.toString();
            this.fromUserId = stringId.split('-')[0];
            this.fromStructureId = stringId.split('-')[1];
        },
        selectToUserQuery(item) {
            this.toUserQuery = item;
            var stringId = item.id.toString();
            this.toUserId = stringId.split('-')[0];
        },
        selectToStructureQuery(item) {
            this.toStructureQuery = item;
            console.log("item = ", item);
            var stringId = item.id.toString();
            this.toStructureId = stringId.split('-')[0];
            if(this.fromStructureId == this.toStructureId)
            {
                window.showAlert('res_Msgs_SameStructureSelected', 'warning');
                this.toStructureQuery = { id: 0, name: '' };
                this.toStructureId = 0;
            }
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;
            this.getAllOpenedTransferForUser();
        },
        itemSelected(item) {
            this.selectedTransfers = item;
        },
        openAddToUserDialog() {
            this.addToUserDialog = true;
        },
        async getAllOpenedTransferForUser() {
            try {
                if(this.fromUserId == 0)
                {
                    window.showAlert("res_Msgs_NoSelectedUser", 'warning');
                    return;
                }
                this.all_transfers = [];
                this.selectedTransfers = [];
                window.showLoading();
                const response = await axios.get(constants.baseApiUrl + 'Admin/GetAllOpenedTransfersForUser?userId=' + this.fromUserId + '&pageSize=' + this.pagingData.pageSize + '&pageIndex=' + this.pagingData.pageIndex);
                this.all_transfers = response.data.transfers;
                this.pagingData.totalCount = response.data.totalRecords;
                this.isMoveBtnDisabled = this.all_transfers.length != 0 || this.fromUserId == 0;
                this.isMoveWithLettersBtnDisabled = this.all_transfers.length == 0 || this.fromUserId == 0;
            } catch (error) {
                console.log(error);
            }
            finally {
                window.hideLoading();
            }
        },
        setUpReleaseTransfersDialog() {
            this.informationDialogOptions.title = "Release Transfers";
            this.informationDialogOptions.text = "Are you sure you want to release the selected transfers?"
            this.informationDialogOptions.confirmFunction = this.releaseTransfers;
            this.informationDialogOptions.visible = true;
        },
        async releaseTransfers() {
            try {
                window.showLoading();
                const selectedTransferIds = this.selectedTransfers.map(x => x.id);
                const response = await axios.post(constants.baseApiUrl + 'Admin/ReleaseTransfers', selectedTransferIds);
                window.hideLoading();
                await this.getAllOpenedTransferForUser();
                window.showAlert('res_Msgs_TransferReleasedSuccess', 'success');
            } catch (error) {
                console.log(error);
            }
            finally {
                this.selectedTransfers = [];
            }
        },
        setUpCloseTransfersDialog() {
            this.informationDialogOptions.title = "Close Transfers";
            this.informationDialogOptions.text = "Are you sure you want to close the selected transfers?"
            this.informationDialogOptions.confirmFunction = this.closeTransfers;
            this.informationDialogOptions.visible = true;
        },
        async closeTransfers() {
            try {
                window.showLoading();
                const selectedTransferIds = this.selectedTransfers.map(x => x.id);
                const response = await axios.post(constants.baseApiUrl + 'Admin/CloseTransfers', selectedTransferIds);
                window.hideLoading();
                if(response.data == 1)
                {
                    await this.getAllOpenedTransferForUser();
                    window.showAlert('res_Msgs_TransferClosedSuccess', 'success');
                }
                else
                    window.showAlert('res_Msgs_TransferCloseFail', 'error');
            } catch (error) {
                console.log(error);
            }
            finally {
                this.selectedTransfers = [];
            }
        },
        setUpTransferTransfersDialog() {
            if(this.toUserId == 0)
            {
                window.showAlert('res_Msgs_SelectUserToTransferWarning', 'warning');
                return;
            }
            this.informationDialogOptions.title = "Transfer Transfers";
            this.informationDialogOptions.text = "Are you sure you want to transfer the selected transfers?"
            this.informationDialogOptions.confirmFunction = this.transferTransfers;
            this.informationDialogOptions.visible = true;
        },
        async transferTransfers() {
            try {
                window.showLoading();
                const testDto = {
                    transferIds: this.selectedTransfers.map(x => x.id),
                    toUserId: this.toUserId
                };
                const response = await axios.post(constants.baseApiUrl + 'Admin/TransferTheTransfers', testDto);
                window.hideLoading();
                if(response.data > 1)
                {
                    await this.getAllOpenedTransferForUser();
                    window.showAlert('res_Msgs_TransfersTransferedSuccess', 'success');
                    this.addToUserDialog = false;
                }
                else
                    window.showAlert('res_Msgs_TransfersTransferedFail', 'error');
            } catch (error) {
                console.log(error);
            }
            finally {
                this.selectedTransfers = [];
            }
        },
        setUpMoveUserToStructureDialog() {
            this.informationDialogOptions.title = "Move User To New Structure";
            this.informationDialogOptions.text = "Are you sure you want to move the selected user to the new structure?"
            this.informationDialogOptions.confirmFunction = this.moveActionType == 1 ? this.moveUserToStructure : this.moveWithLettersToStructure;
            this.informationDialogOptions.visible = true;
        },
        resetInputs() {
            this.fromUserQuery = { id: 0, name: '' };
            this.fromUserId = 0;
            this.fromStructureId = 0;
            this.toUserQuery = { id: 0, name: '' };
            this.toUserId = 0;
            this.toStructureQuery = { id: 0, name: '' };
            this.toStructureId = 0;
            this.isMoveBtnDisabled = true;
            this.isMoveWithLettersBtnDisabled = true;
        },
        async moveUserToStructure() {
            try {
                if(this.toStructureId == 0 || this.fromStructureId == 0 || this.fromUserId == 0)
                {
                    window.showAlert('res_Msgs_SelectStructureToMoveWarning', 'warning');
                    return;
                }
                const dto = {
                    //parse the values as int
                    originalStructureId: parseInt(this.fromStructureId),
                    orginalUserId: parseInt(this.fromUserId),
                    newStructureId: parseInt(this.toStructureId)
                }
                const response = await axios.post(constants.baseApiUrl + 'Admin/MoveUserToNewStructure?originalStructureId=' + dto.originalStructureId + '&orginalUserId=' + dto.orginalUserId + '&newStructureId=' + dto.newStructureId);
                if(response.data > 0)
                {
                    window.showAlert('res_Msgs_MoveUserSuccess', 'success');
                    this.moveToStructureDialog = false;
                    const loggedInUserId = JSON.parse(sessionStorage.getItem('user')).profile.Id;
                    if(loggedInUserId == dto.orginalUserId) {
                        sessionStorage.setItem('user', null)
                        sessionStorage.setItem('jwt_token', null)
                        window.location.href = window.location.origin + '/login2.html'
                    }
                    else 
                        this.resetInputs();
                }
                else
                    window.showAlert('res_Msgs_MoveUserFail', 'error');
            } catch (error) {
                console.log(error);
            }
        },
        async moveWithLettersToStructure() {
            try {
                if(this.toStructureId == 0 || this.fromStructureId == 0 || this.fromUserId == 0)
                {
                    window.showAlert('res_Msgs_SelectStructureToMoveWarning', 'warning');
                    return;
                }
                window.showLoading();
                const dto = {
                    originalStructureId: parseInt(this.fromStructureId),
                    orginalUserId: parseInt(this.fromUserId),
                    newStructureId: parseInt(this.toStructureId)
                }
                const response = await axios.post(constants.baseApiUrl + 'Admin/MoveUserWithLettersToNewStructure?originalStructureId=' + dto.originalStructureId + '&userId=' + dto.orginalUserId + '&newStructureId=' + dto.newStructureId);
                if(response.data > 0)
                {
                    window.showAlert('res_Msgs_MoveUserSuccess', 'success');
                    this.moveToStructureDialog = false;
                    this.all_transfers = [];
                    const loggedInUserId = JSON.parse(sessionStorage.getItem('user')).profile.Id;
                    if(loggedInUserId == dto.orginalUserId) {
                        sessionStorage.setItem('user', null)
                        sessionStorage.setItem('jwt_token', null)
                        window.location.href = window.location.origin + '/login2.html'
                    }
                    else
                        this.resetInputs();
                }
                else
                    window.showAlert('res_Msgs_MoveUserFail', 'error');
            } catch (error) {
                console.log(error);
            }
            finally {
                window.hideLoading();
            }
        }
    }
}
</script>

<style scoped>
#ListCorrespondancesTable table thead th.text-start  {
    background: var(--table-header-color);
    padding-left: 8px !important;
    padding-right: 8px !important;
}
</style>